


















import { Component, Watch } from "vue-property-decorator";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import { ListItemDTO, DashboardNavClient, ContentSearchDataOfContentSearchHit } from "../../Generated/ParticaAPI";
import { ISyndicationArticleService } from "../../BusinessServices/syndication";
import { Article, IArticle } from "../../Models/ArticleModels/article";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import SearchQuery from "@/Ui-Components/Article/Search/SearchQuery.vue";
import SearchResultsStore from "@/Ui-Components/Article/Search/SearchResultsStore.vue";
import SearchFacets from "../../Ui-Components/Article/Search/SearchFacets.vue";
import { ButtonConfig } from "../../Models/Buttons";


@Component({
	name: "SearchArticles",
	components: { ParticaError, ParticaColumnContainer, ParticaRowContainer, SearchQuery, SearchResultsStore, SearchFacets }
})
export default class SearchArticles extends ParticaBaseView {
	private searchData: ContentSearchDataOfContentSearchHit = new ContentSearchDataOfContentSearchHit(
		{
			page: 1,
			query: "",
			top: 30,
			// tslint:disable-next-line
			facets: [
				"publication",
				"syndicationTags",
				"articledate,values:1920-01-01Z|1930-01-01Z|1940-01-01Z|1950-01-01Z|1960-01-01Z|1970-01-01Z|1980-01-01Z|1990-01-01Z|2000-01-01Z|2010-01-01Z|2020-01-01Z|2030-01-01Z",
				"wordCount,values:300|600"
			]
		} as ContentSearchDataOfContentSearchHit);
	private particaStoreService: IParticaStoreService;
	private syndicationArticleService: ISyndicationArticleService;
	/*private articleactions: ButtonConfig[] = [
		// init our menu for the list.
		{ action: eParticaAction.ARTICLE_SELECT, label: "Select" } as ButtonConfig,
	];*/

	private getNumberPages() {

		if (this.searchData.results === undefined) {
			return 1;
		}
		if (this.searchData.top === 0) {
			return 0;
		}
		if (this.searchData !== undefined && this.searchData.top !== undefined) {
			const pages: number = Math.round((this.searchData.results.total_hits as number) / this.searchData.top as number);
			if (pages < 1) {
				return 1;
			}
			return pages;
		}
		return 1;
	}

	private async getPage() {
		// hacky but ok for now
		// also need a spinner.
		// @ts-ignore
		this.$el.parentElement.parentElement.scrollTop = 0;
		this.searchData = await this.particaStoreService.searchArticles(this.searchData);
		this.$nextTick(() => {
			// ?
		});
	}

	private async mounted() {
		this.particaStoreService = this.particaServices.getParticaStoreService();
		this.syndicationArticleService = this.particaServices.getSyndicationArticleService();

	}

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.SEARCH_FACET_UPDATE: {
					this.searchData.page = 1;
					if (this.searchData.filters === undefined) {
						this.searchData.filters = {};
					}
					if (event.item.checked) {
						this.searchData.filters[event.item.facetName] = event.item.value;
					} else {
						delete this.searchData.filters[event.item.facetName];
					}
					this.searchData = await this.particaStoreService.searchArticles(this.searchData);
					break;
				}
				case eParticaAction.DO_SEARCH: {
					this.searchData.filters = undefined;
					this.searchData.query = event.item as string;
					if (this.searchData.query === "") {
						this.searchData.query = "*";
					}
					this.searchData.page = 1;
					this.searchData = await this.particaStoreService.searchArticles(this.searchData);
					break;
				}
				case eParticaAction.ARTICLE_SELECT: {
					this.LoadingStart();
					const article = await this.syndicationArticleService.getSyndicationArticle(event.item.articleId);
					this.$emit("partica-event", article as IArticle);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (e) {
			this.ShowErrorDialog(e, `Unable to process event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}
}
